import React from 'react'
import { Link } from 'react-router-dom'

const AboutSection = () => {
  return (
    <section className="about-section">
  <div className="auto-container">
    <div className="row">
      {/* Image Column */}
      <div className="image-column col-lg-6 col-md-12 col-sm-12">
        <div className="about-image-wrapper">
          <figure className="image-3 wow zoomIn" data-wow-delay="900ms">
            <img src="/assets/images/resource/girl.png" alt="" />
          </figure>
          <figure className="image-2 wow zoomIn" data-wow-delay="600ms">
            <img src="images/resource/writer.png" alt="" />
          </figure>
          <figure className="image-1 wow zoomIn" data-wow-delay="300ms">
            <img src="images/resource/vector.png" alt="" />
          </figure>
          <Link 
            to="https://www.youtube.com/watch?v=kxPCFljwJws"
            className="lightbox-image play-btn wow zoomIn"
            data-wow-delay="1200ms"
          >
            <span className="icon fa fa-play" />
          </Link> 
        </div>
      </div>
      {/* Content Column */}
      <div className="content-column col-lg-6 col-md-12 col-sm-12">
        <div className="inner-column">
          <div className="sec-title">
            <span className="sub-title">WELCOME TO CPC75</span>
            <h2>
              CPC75 Leading Tech Festival <br />
              In-person And Digital
            </h2>
            <span className="divider" />
          </div>
          <p>
            {" "}
            With our in-person tech festival AND our online networking tools,
            you'll be able to attend in Amsterdam and from across the globe.{" "}
          </p>
          <p>
            {" "}
            Rub shoulders with international technology executives, top-tier
            investors, policymakers, startups, and scale-ups, during two days of
            business, knowledge sharing and a whole lot of fun.{" "}
          </p>
          {/* <div className="btn-box">
            <Link  to="buy-ticket.html" className="theme-btn btn-style-one">
              <span className="btn-title">Book Ticket</span>
            </Link> 
          </div> */}
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default AboutSection